import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const PaperCarryBags = () => <ProductDetailPage {...getProductPageConfig('paperCarryBags')} />;

export default PaperCarryBags;
